// extracted by mini-css-extract-plugin
export default {"spinnerWrap":"Loading_spinnerWrap__rbMWV","spinner":"Loading_spinner__99zHJ","loading6454":"Loading_loading6454__t7iK6"};